<template>
    <div class="main">
        <TabListCon :divType="divTypes"></TabListCon>
        <img src="../../static/imgs/bg3.png" class="img" />
        <div class="titleText">
            <div class="title">绿色建筑</div>
            <div class="textMs">让高品质民居走进千家万户</div>
        </div>
        <div class="box">
            <div class="titleMain">
                <div class="titleName">产品详情</div>
                <div class="lineList">
                    <div class="line"></div>
                    <div class="lines"></div>
                    <div class="line"></div>
                </div>
            </div>
            <div class="homeContent">
                <img src="../../static/imgs/home5.jpg" class="hImh">
                <div class="contentMs">
                    <div class="homeName">昆玉系列K1</div>
                    <div class="homeName">流金岁月款</div>
                    <div class="homeLine"></div>
                    <div class="homeMs">
                        <div class="msText">
                            <div class="icon"></div>
                            <div class="textHome">占地面积：约271㎡</div>
                        </div>
                        <div class="msText">
                            <div class="icon"></div>
                            <div class="textHome">建筑面积：约697㎡</div>
                        </div>
                        <div class="msText">
                            <div class="icon"></div>
                            <div class="textHome">主体结构：钢结构</div>
                        </div>
                        <div class="msText">
                            <div class="icon"></div>
                            <div class="textHome">户型布局：七室（四套房）四厅 一厨六卫一阳台一露台一茶室</div>
                        </div>
                        <div class="msText">
                            <div class="icon"></div>
                            <div class="textHome">设计定金：20000</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="nameMS">
            <div class="name">昆玉系列K1</div>
            <div class="ms">从观景到使用，从儿童到长者，全覆盖满足生活需求，蕴藏着设计师以人为本的人文匠心，超大共享空间，交流互动更亲密。</div>
        </div>
        <div class="boxs">
            <img src="../../static/imgs/de8.jpg" class="imgHomeHx">
            <img src="../../static/imgs/de9.jpg" class="imgHomeHx">
            <img src="../../static/imgs/de10.jpg" class="imgHomeHx">
        </div>
        <BottomContentCon></BottomContentCon>
    </div>
</template>
<script>
import TabListCon from "../../components/TabList/index.vue"
import BottomContentCon from "../../components/BottomContent/index.vue"
export default {
    name: "Home",
    data() {
        return {
            divTypes: '3',//顶部Tab组件的index值
        }
    },
    components: { TabListCon, BottomContentCon },
    created() {

    },
    mounted() {

    },
    methods: {
    }
};
</script>

<style scoped>
.imgHomeHx {
    width: 100%;
    height: 1580px;
}

.ms {
    font-size: 38px;
    font-family: PingFangSC;
    font-weight: 400;
    color: #0b5244;
    line-height: 50px;
}

.name {
    font-size: 45px;
    font-family: PingFangSC;
    font-weight: bold;
    color: #0b5244;
    line-height: 65px;
}

.nameMS {
    background-color: #b7c7c4;
    padding: 120px;
    margin-top: 48px;
}

.textHome {
    font-size: 25px;
    font-family: PingFangSC;
    color: #1A1A1A;
    line-height: 50px;
    margin-left: 8px;
}

.icon {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: #000;
}

.msText {
    display: flex;
    align-items: center;

}

.homeMs {
    margin-top: 24px;
}

.homeLine {
    width: 560px;
    height: 6px;
    background-color: #f2b500;
    margin-top: 8px;
}

.homeName {
    font-weight: bold;
    font-size: 38px;
    font-family: PingFangSC;
    color: #f2b500;
    line-height: 60px;
}

.hImh {
    width: 780px;
    height: 420px;
}

.homeContent {
    padding: 62px 0;
    display: flex;
    align-items: start;
}

.contentMs {
    margin-left: 36px;
    margin-top: 12px;
}

.lineList {
    display: flex;
    align-items: center;
    justify-content: center;
}

.line {
    width: 720px;
    height: 4px;
    background-color: #114035;
}

.lines {
    width: 240px;
    height: 30px;
    background-color: #114035;
}

.text {
    color: #979595;
    font-size: 24px;
    line-height: 36px;

}

.titleName {
    color: #333;
    font-size: 64px;
    text-align: center;
    font-weight: bold;
    padding: 160px 0 24px 0;
}


.textMs {
    color: rgba(255, 255, 255, 0.8);
    font-size: 40px;
}

.title {
    color: #fff;
    font-size: 80px;
}

.titleText {
    padding: 145px;
    width: 1500px;
    margin-top: -550px;
    position: absolute;

}

.boxs {
    padding: 24px 120px 24px 120px;
}

.box {
    padding: 0px 120px 0 120px;
}

.img {
    width: 100%;
    height: 693px;
}
</style>